// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","FilterForm__hgroup":"or_a bhy_a bhy_x","FilterForm__vgroup":"or_b bhy_sv"};